// Light Mode Color Foundation

export default {
   // Global
   globalNavLogoFieldName: 'logoDefault',
   tmpBackgroundColor: '#fff',
   tmpBodyTextColor: '#666',
   // Content
   tmpContentBackgroundColor: '#fff',
   tmpContentLineColor: '#eee',
   // Main Menu
   tmpMainMenuBorderColor: '#f3f3f3',
   tmpMainMenuButtonTextColor: '#444',
   tmpMainMenuButtonActiveTextColor: '#000',
   tmpMainMenuButtonActiveBackgroundColor: '#F3F4F4',
   tmpMainMenuLineColor: '#f3f3f3',
   tmpMainMenuTextColor: '#777'
}
